
const setLocationFormat = ({ city, city_id, latitude, longitude, state, state_id }) => ({
  city, city_id, latitude, longitude, state, state_code: state_id
})
export const setPayload = ({
  origin,
  destination,
  status,
  movementNumber
}) => {
  const payload = {}

  if (movementNumber) {
    payload.orderNumber = movementNumber
    return payload
  }

  if (origin) {
    payload.origin = [setLocationFormat(origin)]
  }

  if (destination) {
    payload.destination = [setLocationFormat(destination)]
  }

  if (status && status.value !== 'All') {
    const { value } = status
    if (value === 'Invoiced' || value === 'Not Invoiced') {
      payload.invoiced = value === 'Invoiced'
    } else {
      payload.status = status?.value
    }
  }
  return payload
}

const errorNotify = (error, message) => ({ error, message })

export const validateFilters = ({
  originLocations,
  destinationLocations,
  from,
  radius
}) => {
  if (from?.from === 'destination' && radius?.radius && !destinationLocations.length) {
    return errorNotify(true, 'Unable to filter with radius from destination if an destination is not selected')
  }

  if (from?.from === 'origin' && radius?.radius && !originLocations.length) {
    return errorNotify(true, 'Unable to filter with radius from origin if an origin is not selected')
  }

  if (from?.from === 'both' && radius?.radius && (!originLocations?.length || !destinationLocations?.length)) {
    return errorNotify(true, 'Unable to filter with radius from both if origin and destination are not selected')
  }

  return errorNotify(false, null)
}

export const getOptions = bool => bool ? [
  { value: 'All', label: 'All' },
  { value: 'Invoiced', label: 'Invoiced' },
  { value: 'Not Invoiced', label: 'Not Invoiced' }
] : [
  { value: '0', label: 'Any' },
  { value: 'A', label: 'Available' },
  { value: 'D', label: 'Delivered' },
  { value: 'C', label: 'Covered' },
  { value: 'P', label: 'In Progress' },
  { value: 'V', label: 'Void' }
]
